import legal from '@/data/legalDocuments.json';

type Lead = {
  form_type: 'contact' | 'education' | 'personal_ai' | 'casebook' | 'materials' | 'newsletter';
  name?: string;
  email?: string | null;
  phone?: string | null;
  company?: string | null;
  position?: string;
  contact_method?: string | null;
  message?: string;
  marketing_consent?: boolean;
};

export function leadUtm() {
  const allowed = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'];
  let stored: Record<string, unknown> = {};
  try { stored = JSON.parse(window.sessionStorage.getItem('wmt-initial-utm') || '{}'); } catch { /* URL attribution still works. */ }
  const current = new URLSearchParams(window.location.search);
  const result: Record<string, string> = {};
  for (const key of allowed) {
    const value = current.get(key) || (typeof stored?.[key] === 'string' ? stored[key] as string : '');
    if (value) result[key] = value.slice(0, 300);
  }
  return result;
}

export async function submitLead(lead: Lead) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 15000);
  try {
  const response = await fetch('/request-api/leads', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ ...lead, consent: true, consent_version: legal.version, marketing_consent: lead.marketing_consent === true, marketing_consent_version: lead.marketing_consent === true ? legal.marketingVersion : null, page: window.location.pathname, utm: leadUtm() }),
    signal: controller.signal,
  });
  const result = await response.json();
  if (!response.ok || result.success !== true) throw new Error('Не удалось сохранить заявку');
  return result as { success: true; id: string };
  } finally {
    clearTimeout(timeout);
  }
}
